/**
 * Textarea (adapter) → renders your CommonInput in multiline mode.
 * Keeps the call-site API so existing usages work unchanged, but every
 * multi-line text field is also your Common_Input_Component.
 */

import React from 'react';
import { ViewStyle, TextStyle, TextInputProps } from 'react-native';
import { useTheme } from '../context/themeContext';
import CommonInput from './commonInput';

interface TextareaProps extends Omit<TextInputProps, 'style' | 'multiline'> {
  label?: string;
  hint?: string;
  error?: string;
  minHeight?: number;
  style?: ViewStyle;
  inputStyle?: TextStyle;
}

export default function Textarea({
  label,
  error,
  minHeight = 80,
  style,
  inputStyle,
  value,
  onChangeText,
  placeholder,
  editable,
  hint: _hint,
  ...rest
}: TextareaProps) {
  const { isDark } = useTheme();
  return (
    <CommonInput
      label={label}
      error={error}
      value={(value as string) ?? ''}
      onChangeText={onChangeText}
      placeholder={placeholder}
      editable={editable !== false}
      isDark={isDark}
      containerStyle={[{ marginBottom: 0 }, style]}
      inputProps={{
        ...rest,
        multiline: true,
        textAlignVertical: 'top',
        style: [{ minHeight: minHeight - 16, height: undefined as any }, inputStyle],
      }}
    />
  );
}
